module.exports = __webpack_public_path__ + "img/part3.29b5bcb.png";